import {
    START_POST_UNIQUECOUPON_HOLDS_LOADING, START_POST_UNIQUECOUPON_HOLDS_SUCCESS, START_POST_UNIQUECOUPON_HOLDS_RESET,
    START_POST_UNIQUECOUPON_HOLDS_ERROR
} from "../actions/actionUniqueCouponHolds";

const initialState = {
    UniqueCoupon: {},
    loading: false,
    UniqueCouponError: ''
};

function reducerUniqueCouponHolds(state = initialState, action) {
    switch (action.type) {
        case START_POST_UNIQUECOUPON_HOLDS_LOADING: {
            return {
                ...state,
                loading: true,
                UniqueCoupon: {},
                UniqueCouponError: ''
            };
        }
        case START_POST_UNIQUECOUPON_HOLDS_SUCCESS: {
            return {
                ...state,
                loading: false,
                UniqueCoupon: action.payload[0],
                UniqueCouponError: ''
            };
        }
        case START_POST_UNIQUECOUPON_HOLDS_RESET: {

            return {
                ...state,
                loading: false,
                UniqueCoupon: {},
                UniqueCouponError: ''
            }
        }
        case START_POST_UNIQUECOUPON_HOLDS_ERROR: {


            return {
                ...state,
                loading: false,
                UniqueCoupon: {},
                UniqueCouponError: action.error
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerUniqueCouponHolds;